import "components/DocumentStatusTabs/documentStatusTabs.css";
import useDraftBulkDelete from "hooks/useDraftBulkDelete";
import DraftBulkActions, { DraftCheckbox } from "components/DraftBulkActions";
import ThemedSelect from "components/FormControls/ThemedSelect";
import {
  rctiDocumentState,
  rctiOutstanding,
  rctiPaymentState,
  rctiRegisterSummary,
  rctiMatchesDueRange,
  rctiRegisterOrder,
  rctiMatchesTab,
} from "utils/rctiRegister";
import {
  rctiToday,
  rctiCalendarDate,
  rctiEarliestSupplyDate,
} from "utils/rctiDates";
import { rctiTimestamp } from "utils/rctiTimestamp";
import { documentDateFilterLabel } from "utils/documentDateFilterLabel";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ClearableSearchInput } from "components/SearchField/SearchField";
import {
  Button,
  Card,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import {
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  ContentCopy as ContentCopyIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";
import { GridSearchIcon } from "@mui/x-data-grid";
import axios from "axios";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { appConstants } from "utils/appConstants";
import { clearBillingNumberPreview, getBillingNumberPreview } from "utils/billingNumberPreview";
import { getScreenRight, showResMsg, generateToken } from "utils/generic";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";
import { genericMessage } from "utils/genericMessages";
import { deleteSelectedRCTI } from "utils/invoiceAPI";
import { getRCTI } from "utils/invoiceAPI";
import useFeatureAccess from "utils/useFeatureAccess";
import IconMenu from "components/CustomMaterialMenu/Custom";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { downloadRCTI } from "utils/invoiceAPI";
import { savePdfResponse } from "utils/documentPdf";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingModal from "components/LoadingModel/loadingModal";
import { CardSkeleton, TableSkeleton } from "components/Skeleton";
import { showDraftSavedMessage } from "components/InlineFeedback/DraftSaveConfirmation";
import { Email as EmailIcon } from "@mui/icons-material";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { toast } from "react-toastify";
import SendInvoiceModal from "layouts/Invoices/SendInvoiceModal";
import { resendEmailRcti } from "utils/invoiceAPI";
import select from "assets/theme/components/form/select";
import { formatCurrencyAUD } from "utils/formatCurrency";
import AppHeader from "components/AppHeader";
import ListingActionMenu from "components/ListingActionMenu";
import { DashboardNavigation } from "layouts/businessUserDashboard";
import DebitNoteResponsiveHeader from "layouts/DebitNote/DebitNoteResponsiveHeader";
import {
  LuCoins,
  LuEllipsis,
  LuFileText,
  LuSearch,
  LuPlus,
  LuPencil,
  LuEye,
  LuTrash2,
  LuMail,
  LuCopy,
  LuDownload,
  LuChevronLeft,
  LuChevronRight,
} from "react-icons/lu";
import "layouts/Quotation/quotation.css";
import "layouts/Invoices/invoiceFlow.css";
import "./rctiFlow.css";
import "./rctiDesign.css";
import "./rctiDashboard.css";
import "./rctiResponsive.css";

const SCREEN_NAME = "RCTI";
let SCREEN_RIGHT;

const getRctiDisplayStatus = rctiDocumentState;

const getRctiOpenPath = (row) =>
  `/rcti/${getRctiDisplayStatus(row) === "Draft" ? "edit" : "view"}/${row._id}`;
const getContactOpenPath = (row) => {
  const contact = row?.supplierID ?? row?.contactID ?? row?.supplier;
  const contactId = typeof contact === "object" ? contact?._id : contact;
  return contactId ? `/contacts/${contactId}` : null;
};
const isInteractiveRowTarget = (target) =>
  Boolean(
    target?.closest?.(
      "a, button, input, select, textarea, [role='button'], [role='menu'], [role='menuitem'], .MuiButtonBase-root, .rcti-row-actions"
    )
  );

const getRctiOutstanding = rctiOutstanding;
const formatRctiDate = (value) => {
  if (!value) return "Not set";
  const day = /^\d{4}-\d{2}-\d{2}/.test(String(value))
    ? `${String(value).slice(0, 10)}T12:00:00Z`
    : value;
  const parsed = new Date(day);
  return Number.isFinite(parsed.getTime())
    ? parsed.toLocaleDateString("en-AU", {
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "UTC",
      })
    : "Not set";
};

function InvoicesSearch() {
  const featureAccess = useFeatureAccess();
  const [resetClicked, setResetClicked] = useState(false);
  const currency = useSelector((state) => state.currency.currencySymbol);
  const navigate = useNavigate();
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const dispatch = useDispatch();
  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
  );
  useEffect(() => {
    if (loginDetails?.businessUserID) {
      clearBillingNumberPreview("rcti", loginDetails.businessUserID);
      getBillingNumberPreview("rcti", loginDetails.businessUserID).catch(() => {});
    }
  }, [loginDetails?.businessUserID]);
  console.log("loginDetails", loginDetails);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [navOpen, setNavOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("All");
  const [supplierFilter, setSupplierFilter] = useState("");
  const [supplyDateFilter, setSupplyDateFilter] = useState("All dates");
  const [openRowMenu, setOpenRowMenu] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const [values, setValues] = useState({
    businessUserID: loginDetails?.businessUserID,
    sortingType: "",
    sortingField: "",
    rctiStatus: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: 1,
    limit: 10,
    filterValues: "",
    searchParameterList: [
      "rctiStatus",
      "rctiDate",
      "supplyDate",
      "supplierName",
      "rctiNumber",
      "quotationNumber",
      "finalAmount",
      "supplierCompanyName",
      "purchaseOrderNumber",
    ],
  });
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [screenAccess, setScreenAccess] = useState(false);
  const searchEffectReady = useRef(false);

  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "RCTI",
    userEmailAddress: "",
    customerEmailAddress: [],
    emailTemplate: "",
  });
  const [emailRow, setEmailRow] = useState(null);
  const [emailSending, setEmailSending] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let sType = new URLSearchParams(window.location.search).get(
          "rctiStatus"
        );
        if (sType) {
          values.rctiStatus = sType;
        }

        let duration = new URLSearchParams(window.location.search).get(
          "duration"
        );
        let customFrom = new URLSearchParams(window.location.search).get(
          "from"
        );
        let customTo = new URLSearchParams(window.location.search).get("to");
        duration && (values.durationDate = duration);
        customFrom && (values.fromDate = customFrom);
        customTo && (values.toDate = customTo);
        sessionStorage.removeItem("HoldQuotationData");
        sessionStorage.removeItem("deletedItems");
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
        await getRight();
        await fetchRCTI();
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };
    fetchData();
  }, []);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    console.log("dfvjd", SCREEN_RIGHT);
    setScreenAccess(SCREEN_RIGHT === "Full Access");
  }

  const fetchRCTI = async () => {
    setLoading(true);
    setLoadError("");
    try {
      const { data } = await axios.post(
        appConstants.baseURL + "invoice/fetchRCTI",
        {
          businessUserID: loginDetails?.businessUserID,
          allRegisterRows: true,
          page: 1,
          limit: 100,
          rctiStatus: "All",
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
          },
        }
      );
      if (!data.Result_Status || !Array.isArray(data.Result_Output?.docs))
        throw new Error(data.Result_Message || "Unable to load RCTIs.");
      setRows(data.Result_Output.docs);
      setTotalRows(data.Result_Output.docs.length);
      dispatch(IdleAction(new Date()));
    } catch (error) {
      if (error.response?.data?.Result_Message === "TokenExpiredError") {
        await generateToken(loginDetails?._id, dispatch);
        return;
      }
      setLoadError(
        error.response?.data?.Result_Message ||
          error.message ||
          "Unable to load RCTIs."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCloneRCTI = async (id, RCTI_No) => {
    dispatch(loadingAction(true));
    try {
      const response = await axios.post(
        appConstants.baseURL + "invoice/cloneRCTI",
        {
          businessUserID: values.businessUserID,
          rctiID: id,
          userID: loginDetails?._id,
        },
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` } }
      );
      const { Result_Status: status, Result_Output: output, Result_Message: message } = response.data;
      if (output === "NO AVAILABLE CREDITS") {
        setShowBillingModal(true);
        return;
      }
      if (!status || !output?._id) {
        showResMsg(message || `Unable to clone ${RCTI_No || "RCTI"}.`, 2500, false);
        return;
      }
      clearBillingNumberPreview("rcti", values.businessUserID);
      navigate(`/rcti/edit/${output._id}`);
    } catch (error) {
      if (error.response?.status === 409 && /active RCTI agreement|eligible RCTI agreement/i.test(error.response?.data?.Result_Message || "")) {
        navigate(`/rcti/add?type=new&cloneFrom=${encodeURIComponent(id)}`);
        showResMsg("Details and supplier copied. The supplier needs an active eligible agreement before saving.", 5000, true);
        return;
      }
      showResMsg(error.response?.data?.Result_Message || "Unable to clone this RCTI.", 2500, false);
    } finally {
      dispatch(loadingAction(false));
    }
  };
  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handleSort = (column, sortDirection) =>
    setValues((current) => ({
      ...current,
      sortingField: column,
      sortingType: sortDirection,
      page: 1,
    }));
  const getAriaSort = (column) =>
    values.sortingField === column
      ? values.sortingType === 1
        ? "ascending"
        : "descending"
      : "none";
  const handlePageChange = (page) =>
    setValues((current) => ({ ...current, page }));
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setValues((current) => ({ ...current, page }));
  };

  const handleDownload = (id, number) =>
    downloadRCTI(
      { _id: id },
      (response) => savePdfResponse(response, `rcti_${number || id}.pdf`),
      dispatch
    );

  const handleClose = () => {
    if (emailSending) return;
    setOpen(false);
  };

  const handleSend = (templateData) => {
    if (!templateData || emailSending) return;
    const formdata = new FormData();
    formdata.append("selectedID", templateData.selectedID);
    formdata.append("userEmailAddress", templateData.userEmailAddress);
    formdata.append("customerEmailAddress", [...templateData.customerEmailAddress]);
    formdata.append(
      "emailTemplate",
      JSON.stringify({ ...templateData.emailTemplate })
    );
    formdata.append("sendMeCopy", templateData.sendMeCopy);
    formdata.append("businessUserID", values.businessUserID);
    setEmailSending(true);
    dispatch(loadingAction(true));
    return new Promise((resolve) => resendEmailRcti(
      formdata,
      (data) => {
        let status = data.Result_Status;
        if (!status) showResMsg(data.Result_Message, 2000, false);
        setEmailSending(false);
        resolve({ success: Boolean(status), message: data.Result_Message });
        if (status) {
          setOpen(false);
          showDraftSavedMessage("RCTI sent successfully");
          fetchRCTI();
        }
      },
      dispatch
    ));
  };

  const handleEmailQuotation = async (selectedRow) => {
    if (!selectedRow.finalAmount || selectedRow.finalAmount <= 0) {
      showResMsg("No item added", 2000, false);
      return;
    }
    await getEmailAndTemplateForQuotation(
      {
        screenType: "RCTI",
        contactID: selectedRow.supplierID,
        selectedID: selectedRow._id,
        userID: String(
          sessionStorage.getItem("USER_ID") || loginDetails?._id || ""
        ).replaceAll('"', ""),
      },
      (data) => {
        if (data.Result_Status) {
          setTemplateValues(data.Result_Output);
          setEmailRow(selectedRow);
          setOpen(true);
        } else {
          showResMsg(data.Result_Message || "Unable to load the RCTI email.", 2000, false);
          setOpen(false);
        }
      },
      dispatch
    );
  };

  const closeRowMenu = () => {
    setOpenRowMenu(null);
    setMenuAnchorEl(null);
  };

  const renderRowActions = (row, className = "") => {
    const documentState = getRctiDisplayStatus(row);
    const isDraft = documentState === "Draft";
    const isVoided = documentState === "Voided";
    const canSend =
      screenAccess && !isDraft && !isVoided && row.rctiStatus === "Unpaid";
    const openLabel = isDraft && screenAccess ? "Resume" : "View";

    return (
      <div className={`rcti-row-actions ${className}`.trim()}>
        <button
          type="button"
          className="quotation-dots-btn listing-action-trigger"
          aria-label={`Actions for ${row.rctiNumber}`}
          aria-haspopup="menu"
          aria-expanded={openRowMenu === row._id}
          onClick={(event) => {
            const isOpen = openRowMenu === row._id;
            setOpenRowMenu(isOpen ? null : row._id);
            setMenuAnchorEl(isOpen ? null : event.currentTarget);
          }}
        >
          <LuEllipsis aria-hidden="true" />
        </button>
        {openRowMenu === row._id && (
          <ListingActionMenu
            anchorEl={menuAnchorEl}
            label={`Actions for ${row.rctiNumber}`}
            onClose={closeRowMenu}
          >
            <Link
              className="quotation-menu-item"
              to={
                isDraft && !screenAccess
                  ? `/rcti/view/${row._id}`
                  : getRctiOpenPath(row)
              }
              onClick={closeRowMenu}
            >
              <LuEye className="quotation-menu-icon" />
              <span>{openLabel}</span>
            </Link>
            {screenAccess && !isDraft && !isVoided && (
              <Link
                className="quotation-menu-item"
                to={`/rcti/edit/${row._id}`}
                onClick={closeRowMenu}
              >
                <LuPencil className="quotation-menu-icon" />
                <span>Create adjustment</span>
              </Link>
            )}
            {canSend ? (
              <button
                type="button"
                className="quotation-menu-item"
                onClick={() => {
                  closeRowMenu();
                  handleEmailQuotation(row);
                }}
              >
                <LuMail className="quotation-menu-icon" />
                <span>
                  {row.emailSent > 0 ? "Resend email" : "Send email"}
                </span>
              </button>
            ) : !screenAccess ? null : (
              <span
                className="quotation-menu-item disabled"
                aria-disabled="true"
              >
                <LuMail className="quotation-menu-icon" />
                <span>Send / resend email</span>
              </span>
            )}
            {screenAccess && (
              <button
                type="button"
                className="quotation-menu-item"
                onClick={() => {
                  closeRowMenu();
                  handleCloneRCTI(row._id, row.rctiNumber);
                }}
              >
                <LuCopy className="quotation-menu-icon" />
                <span>Clone RCTI</span>
              </button>
            )}
            <button
              type="button"
              className="quotation-menu-item"
              onClick={() => {
                closeRowMenu();
                handleDownload(row._id, row.rctiNumber);
              }}
            >
              <LuDownload className="quotation-menu-icon" />
              <span>Download PDF</span>
            </button>
            {screenAccess && isDraft ? (
              <button
                type="button"
                className="quotation-menu-item quotation-menu-item-delete"
                onClick={() => {
                  closeRowMenu();
                  handleDeleteDialogeClick(row._id);
                }}
              >
                <LuTrash2 className="quotation-menu-icon" />
                <span>Delete draft</span>
              </button>
            ) : screenAccess ? (
              <span
                className="quotation-menu-item disabled"
                aria-disabled="true"
                title="Issued RCTIs are retained for accounting history"
              >
                <LuTrash2 className="quotation-menu-icon" />
                <span>Delete</span>
              </span>
            ) : null}
          </ListingActionMenu>
        )}
      </div>
    );
  };
  const handleDeleteDialogeClick = async (value) => {
    console.log("id", value);
    values._id = value;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };
  const handleDelete = async (id) => {
    deleteRCTI();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteRCTI = async () => {
    console.log("fffffvalues", values);
    try {
      setLoading(true);
      values.token = loginDetails.token;
      console.log("values.token", values.token);

      await axios
        .post(appConstants.baseURL + "invoice/deleteRCTI", values, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
          },
        })
        .then((res) => {
          let response = res.data;
          console.log("response", response);
          if (response.Result_Status) {
            fetchRCTI();
            showResMsg(genericMessage.deleted, 1000, res.data.Result_Status);
            setLoading(false);
          } else {
            setLoading(false);
            showResMsg(response.Result_Message, 2000, false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in deleteRCTI API=", error);
        });
    } catch (error) {
      console.log("Catch in deleteRCTI API=", error);
    }
  };

  const handleAddNew = () => {
    if (featureAccess) {
      if (SCREEN_RIGHT !== "Full Access") {
        showResMsg(genericMessage.notPermission, 2000, false);
      } else {
        navigate("/rcti/add?type=new");
      }
    } else {
      setShowBillingModal(true);
    }
  };
  const handleSearchInputValue = useCallback((searchInput) => {
    setValues((prevValues) => ({ ...prevValues, filterValues: searchInput }));
  }, []);

  const getSearchResult = useCallback(() => {
    setValues((current) => ({ ...current, page: 1 }));
  }, []);
  useEffect(() => {
    if (!searchEffectReady.current) {
      searchEffectReady.current = true;
      return;
    }
    // eslint-disable-next-line eqeqeq
    if (values.filterValues.length == "") {
      getSearchResult();
    }
  }, [values.filterValues]);

  const handleRefreshButtonClick = () => {
    // fetchQuotations();
    setValues((prevValues) => ({
      ...prevValues,
      sortingType: "",
      sortingField: "",
      rctiStatus: "All",
      activityStatus: "All",
      durationDate: "",
      fromDate: "",
      toDate: "",
      page: appConstants.page,
      limit: appConstants.limit,
      sendEmailFlag: false,
      businessUserID: loginDetails?.businessUserID,
      filterValues: "",

      searchParameterList: [
        "rctiStatus",
        "rctiDate",
        "supplyDate",
        "supplierName",
        "rctiNumber",
        "quotationNumber",
        "finalAmount",
        "supplierCompanyName",
        "purchaseOrderNumber",
      ],
    }));
    setResetClicked(true);
    setActiveTab("All");
    setSupplierFilter("");
    setSupplyDateFilter("All dates");
  };
  useEffect(() => {
    if (resetClicked) {
      fetchRCTI();
      setResetClicked(false);
    }
  }, [resetClicked]);
  const organisationName =
    loginDetails?.businessName ||
    loginDetails?.companyName ||
    loginDetails?.organisationName ||
    loginDetails?.organizationName ||
    loginDetails?.fullName ||
    loginDetails?.name ||
    [loginDetails?.firstName, loginDetails?.lastName]
      .filter(Boolean)
      .join(" ") ||
    "Invoice & Recover";
  const displayCurrency = loginDetails?.currencyCode || "AUD";
  const suppliers = [
    ...new Set(
      rows
        .map((row) => row.supplierCompanyName || row.supplierName)
        .filter(Boolean)
    ),
  ].sort();
  const money = (amount) =>
    new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: displayCurrency,
    }).format(Number(amount || 0));
  const today = rctiToday();
  const baseRows = rows
    .filter(
      (row) =>
        !supplierFilter ||
        (row.supplierCompanyName || row.supplierName) === supplierFilter
    )
    .filter((row) => rctiMatchesDueRange(row, supplyDateFilter, today))
    .filter((row) => {
      const query = String(values.filterValues || "")
        .trim()
        .toLowerCase();
      return (
        !query ||
        [
          row.rctiNumber,
          row.supplierCompanyName,
          row.supplierName,
          row.purchaseOrderNumber,
        ].some((value) =>
          String(value || "")
            .toLowerCase()
            .includes(query)
        )
      );
    });
  const filteredRows = baseRows
    .filter((row) => rctiMatchesTab(row, activeTab, today))
    .sort((first, second) => {
      if (!values.sortingField) return rctiRegisterOrder(first, second);
      const key = values.sortingField;
      const difference =
        key === "finalAmount"
          ? Number(first[key] || 0) - Number(second[key] || 0)
          : String(first[key] || "").localeCompare(String(second[key] || ""));
      return difference * Number(values.sortingType || 1);
    });
  const currentPage = Math.min(
    Math.max(1, Number(values.page)),
    Math.max(1, Math.ceil(filteredRows.length / perPage))
  );
  const displayRows = filteredRows.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );
  const draftBulk = useDraftBulkDelete({
    enabled: activeTab === "Draft" && screenAccess,
    rows: displayRows.filter((row) => rctiDocumentState(row) === "Draft"),
    scopeKey: JSON.stringify([activeTab, currentPage, values.filterValues, supplierFilter, supplyDateFilter]),
    loading, endpoint: "invoice/deleteRCTI", businessUserID: loginDetails?.businessUserID,
    permanent: true, onDeleted: fetchRCTI,
  });
  const summary = rctiRegisterSummary(baseRows, today);
  const getTabCount = (state) =>
    baseRows.filter((row) => rctiMatchesTab(row, state, today)).length;
  const tabOptions = [
    { label: `All records (${baseRows.length})`, value: "All" },
    { label: `Issued (${getTabCount("Issued")})`, value: "Issued" },
    { label: `Drafts (${getTabCount("Draft")})`, value: "Draft" },
    { label: `Paid (${getTabCount("Paid")})`, value: "Paid" },
    { label: `Part-paid (${getTabCount("Part-paid")})`, value: "Part-paid" },
    { label: `Overdue (${getTabCount("Overdue")})`, value: "Overdue" },
    { label: `Voided (${getTabCount("Voided")})`, value: "Voided" },
  ];
  useEffect(() => {
    setValues((current) => ({ ...current, page: 1 }));
  }, [supplierFilter, supplyDateFilter, activeTab, values.filterValues]);
  const showClearFilters =
    Boolean(values.filterValues.trim()) ||
    Boolean(supplierFilter) ||
    supplyDateFilter !== "All dates";
  const filtersActive = activeTab !== "All" || showClearFilters;

  return (
    <div
      className={`rcti-flow-shell rcti-list-shell business-dashboard${
        darkMode ? " dark" : ""
      }`}
      data-theme={darkMode ? "dark" : "light"}
    >
      <DashboardNavigation
        open={navOpen}
        onClose={() => setNavOpen(false)}
        activePath="/rcti"
        organisation={organisationName}
        role={loginDetails?.roleName || "Owner"}
      />
      <div className="dashboard-main rcti-flow-main">
        <AppHeader
          searchPlaceholder="Search RCTIs, suppliers, contacts"
          onOpenNav={() => setNavOpen(true)}
        />
        <DebitNoteResponsiveHeader
          organisation={organisationName}
          role={loginDetails?.roleName || "Owner"}
        />
        <main className="dashboard-content rcti-list-page rcti-c01-dashboard">
          <header className="rcti-list-heading">
            <div>
              <p className="rcti-design-breadcrumb">Buy / RCTIs</p>
              <h1>RCTIs</h1>
              <p>
                Create recipient created tax invoices and track supplier
                payables.
              </p>
            </div>
            <div className="rcti-header-actions">
              <Link className="rcti-secondary-button" to="/rcti-agreements">
                Agreements
              </Link>
              <button
                type="button"
                className="rcti-primary-button"
                onClick={handleAddNew}
              >
                <LuPlus />
                New RCTI
              </button>
            </div>
            <div className="rcti-list-context">
              <span>
                {organisationName} · Buyer / issuer · All {filteredRows.length}{" "}
                records · {supplyDateFilter} · {displayCurrency} incl. GST
              </span>
              <span>
                {documentDateFilterLabel(
                  supplyDateFilter,
                  new Date(`${today}T12:00:00`)
                )}
              </span>
            </div>
          </header>
          {loadError && (
            <div role="alert" className="rcti-c01-load-error">
              <span>{loadError}</span>
              <button type="button" onClick={fetchRCTI}>
                Retry
              </button>
            </div>
          )}
          <section
            className="rcti-financial-summary"
            aria-label="RCTI payable summary"
          >
            {loading ? (
              <CardSkeleton variant="stat" count={3} />
            ) : (
              <>
                {[
                  [
                    "Outstanding payable",
                    summary.outstanding,
                    `${summary.outstandingCount} issued records with a balance`,
                  ],
                  [
                    "Overdue payable",
                    summary.overdue,
                    `${summary.overdueCount} overdue · included in outstanding`,
                  ],
                  [
                    `Drafts (${summary.draftCount})`,
                    summary.drafts,
                    "Estimated value · Not payable",
                  ],
                ].map(([title, amount, description]) => (
                  <article className="rcti-financial-card" key={title}>
                    <div>
                      <h2>{title}</h2>
                      <LuCoins aria-hidden="true" />
                    </div>
                    <strong>{money(amount)}</strong>
                    <p>{description}</p>
                  </article>
                ))}
              </>
            )}
            <p className="rcti-summary-note">
              Overdue is included in outstanding.
              Drafts are excluded from payables; paid records have no balance.
            </p>
          </section>
          <section className="rcti-filters" aria-label="Filter RCTIs">
            <div className="draft-bulk-header">
            <div
              className="rcti-status-tabs document-status-tabs"
              role="tablist"
              aria-label="RCTI status"
            >
              {tabOptions.map((tab) => (
                <button
                  key={tab.value}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === tab.value}
                  className={activeTab === tab.value ? "is-active" : ""}
                  onClick={() => {
                    setActiveTab(tab.value);
                    setValues((current) => ({ ...current, page: 1 }));
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <DraftBulkActions bulk={draftBulk} />
            </div>
            <div className="rcti-list-filter-row">
              <label className="rcti-list-search">
                <LuSearch />
                <ClearableSearchInput
                  id="rcti-list-search"
                  value={values.filterValues}
                  placeholder="Search reference or supplier"
                  onChange={(event) =>
                    handleSearchInputValue(event.target.value)
                  }
                  onKeyDown={(event) => {
                    if (event.key === "Enter") getSearchResult();
                  }}
                />
                <button
                  type="button"
                  aria-label="Search RCTIs"
                  onClick={getSearchResult}
                >
                  <LuSearch />
                </button>
              </label>
              <div className="rcti-filter-select">
                <span className="sr-only">Supplier</span>
                <ThemedSelect
                  dark={darkMode}
                  aria-label="Supplier"
                  value={supplierFilter}
                  onChange={(event) => setSupplierFilter(event.target.value)}
                >
                  <option value="">All suppliers</option>
                  {suppliers.map((supplier) => (
                    <option key={supplier} value={supplier}>
                      {supplier}
                    </option>
                  ))}
                </ThemedSelect>
              </div>
              <div className="rcti-filter-select rcti-due-select">
                <span className="sr-only">Due date range</span>
                <ThemedSelect
                  dark={darkMode}
                  aria-label="Due date range"
                  value={supplyDateFilter}
                  onChange={(event) => setSupplyDateFilter(event.target.value)}
                >
                  <option value="All dates">All due dates</option>
                  <option value="Overdue">Overdue</option>
                  <option value="Due this week">Due this week</option>
                  <option value="Due this month">Due this month</option>
                </ThemedSelect>
              </div>
              {showClearFilters && (
                <button
                  type="button"
                  className="quotation-clear-filters-action"
                  onClick={handleRefreshButtonClick}
                >
                  Clear filters
                </button>
              )}
              <span className="rcti-c01-filter-count">
                {filteredRows.length} records
              </span>
              <Button
                className="rcti-refresh-button"
                title="Reset filters"
                onClick={handleRefreshButtonClick}
              >
                <RefreshIcon />
              </Button>
            </div>
          </section>
          <section
            className="quotation-table-card rcti-table-card"
            aria-label="RCTI register"
          >
            <div className="quotation-table-context">
              <strong>
                {activeTab === "All"
                  ? "All RCTI records"
                  : activeTab === "Draft"
                  ? "Draft RCTI records"
                  : `${activeTab} RCTI records`}
              </strong>
              <span>
                Outstanding first · Draft references are internal only
              </span>
            </div>
            {loading || displayRows.length > 0 ? (
              <>
                <div className="quotation-table-scroll rcti-register-table">
                  <table aria-busy={loading}>
                    <thead>
                      <tr>
                        <th aria-sort={getAriaSort("rctiNumber")}>
                          <button
                            className="rcti-sort-heading"
                            onClick={() =>
                              handleSort(
                                "rctiNumber",
                                values.sortingType === 1 ? -1 : 1
                              )
                            }
                          >
                            Reference
                          </button>
                        </th>
                        <th aria-sort={getAriaSort("supplierCompanyName")}>
                          <button
                            className="rcti-sort-heading"
                            onClick={() =>
                              handleSort(
                                "supplierCompanyName",
                                values.sortingType === 1 ? -1 : 1
                              )
                            }
                          >
                            Supplier / vendor
                          </button>
                        </th>
                        <th aria-sort={getAriaSort("rctiDate")}>
                          <button
                            className="rcti-sort-heading"
                            onClick={() =>
                              handleSort(
                                "rctiDate",
                                values.sortingType === 1 ? -1 : 1
                              )
                            }
                          >
                            Dates
                          </button>
                        </th>
                        <th>Document / delivery</th>
                        <th>Payment</th>
                        <th
                          className="rcti-heading-money"
                          aria-sort={getAriaSort("finalAmount")}
                        >
                          <button
                            className="rcti-sort-heading"
                            onClick={() =>
                              handleSort(
                                "finalAmount",
                                values.sortingType === 1 ? -1 : 1
                              )
                            }
                          >
                            Total / est.
                          </button>
                        </th>
                        <th className="rcti-heading-money">Outstanding</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <TableSkeleton
                          variant="rows"
                          columns={8}
                          rows={6}
                          hasActions={false}
                        />
                      ) : (
                        displayRows.map((row) => {
                          const state = getRctiDisplayStatus(row),
                            payment = rctiPaymentState(row, today),
                            draft = state === "Draft";
                          return (
                            <tr
                              key={row._id}
                              onClick={(event) => {
                                if (!isInteractiveRowTarget(event.target))
                                  navigate(getRctiOpenPath(row));
                              }}
                            >
                              <td>
                                <DraftCheckbox bulk={draftBulk} id={row._id} label={row.rctiNumber} />
                                <Link
                                  to={getRctiOpenPath(row)}
                                  className="quotation-mono-link"
                                >
                                  {row.rctiNumber || "Draft"}
                                </Link>
                                {Number(row.version) > 1 && (
                                  <small>Version {row.version}</small>
                                )}
                              </td>
                              <td>
                                {getContactOpenPath(row) ? (
                                  <Link
                                    className="rcti-contact-link"
                                    to={getContactOpenPath(row)}
                                  >
                                    {row.supplierCompanyName ||
                                      row.supplierName ||
                                      "—"}
                                  </Link>
                                ) : (
                                  row.supplierCompanyName ||
                                  row.supplierName ||
                                  "—"
                                )}
                              </td>
                              <td>
                                <time
                                  dateTime={row.issuedAt || row.rctiDate}
                                  title={rctiTimestamp(
                                    row.issuedAt ||
                                      row.createdDate ||
                                      row.rctiDate
                                  )}
                                >
                                  {formatRctiDate(row.rctiDate)}
                                </time>
                                <small>
                                  {row.dueDate
                                    ? `${
                                        draft ? "Planned due: " : "Due "
                                      }${formatRctiDate(row.dueDate)}`
                                    : draft
                                    ? "Planned due: not set"
                                    : "Due date: not set"}
                                </small>
                              </td>
                              <td>
                                <span
                                  className={`rcti-status-pill rcti-document-${state.toLowerCase()}`}
                                >
                                  {state}
                                </span>
                                <small>
                                  Delivery:{" "}
                                  {Number(row.emailSent) > 0
                                    ? "Sent"
                                    : "Not sent"}
                                </small>
                              </td>
                              <td>
                                <span
                                  className={`rcti-status-pill rcti-payment-${payment
                                    .toLowerCase()
                                    .replaceAll(" ", "-")}`}
                                >
                                  {payment}
                                </span>
                                {getRctiOutstanding(row) > 0 &&
                                  Number(row.paymentAmount) > 0 && (
                                    <small>
                                      {money(row.paymentAmount)} paid
                                    </small>
                                  )}
                              </td>
                              <td className="rcti-table-money">
                                {money(row.finalAmount)}
                              </td>
                              <td className="rcti-table-money">
                                {draft || state === "Voided"
                                  ? "—"
                                  : money(getRctiOutstanding(row))}
                              </td>
                              <td className="rcti-c01-actions">
                                {renderRowActions(row)}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="rcti-mobile-register">
                  {loading ? (
                    <TableSkeleton
                      variant="div"
                      columns={4}
                      rows={6}
                      hasHeader={false}
                      hasActions={false}
                    />
                  ) : (
                    displayRows.map((row) => {
                      const state = getRctiDisplayStatus(row),
                        draft = state === "Draft",
                        payment = rctiPaymentState(row, today);
                      return (
                        <article
                          className="rcti-register-mobile-card"
                          key={row._id}
                        >
                          <div className="rcti-mobile-card-top">
                            <DraftCheckbox bulk={draftBulk} id={row._id} label={row.rctiNumber} />
                            <Link
                              className="rcti-register-number"
                              to={getRctiOpenPath(row)}
                            >
                              {row.rctiNumber || "Draft"}
                            </Link>
                            <span
                              className={`rcti-status-pill rcti-payment-${payment
                                .toLowerCase()
                                .replaceAll(" ", "-")}`}
                            >
                              {payment}
                            </span>
                            {renderRowActions(row, "rcti-mobile-actions-menu")}
                          </div>
                          <strong>
                            {row.supplierCompanyName || row.supplierName || "—"}
                          </strong>
                          <p>
                            {formatRctiDate(row.rctiDate)} ·{" "}
                            {row.dueDate
                              ? `Due ${formatRctiDate(row.dueDate)}`
                              : "Due date not set"}
                          </p>
                          <p>
                            <span
                              className={`rcti-status-pill rcti-document-${state.toLowerCase()}`}
                            >
                              {state}
                            </span>{" "}
                            · Delivery:{" "}
                            {Number(row.emailSent) > 0 ? "Sent" : "Not sent"}
                          </p>
                          <div className="rcti-mobile-financials">
                            <div>
                              <small>Total / est.</small>
                              <strong>{money(row.finalAmount)}</strong>
                            </div>
                            <div>
                              <small>Outstanding</small>
                              <strong>
                                {draft || state === "Voided"
                                  ? "—"
                                  : money(getRctiOutstanding(row))}
                              </strong>
                            </div>
                          </div>
                        </article>
                      );
                    })
                  )}
                </div>
              </>
            ) : (
              <div className="rcti-list-empty">
                <LuFileText />
                <strong>
                  {rows.length
                    ? "No RCTIs match these filters"
                    : "No RCTIs yet"}
                </strong>
                <span>
                  {rows.length
                    ? "Try changing the status, supplier or due-date range."
                    : "Create your first RCTI to start tracking supplier payables."}
                </span>
                {!filtersActive && (
                  <button type="button" onClick={handleAddNew}>
                    <LuPlus />
                    New RCTI
                  </button>
                )}
              </div>
            )}
            <footer className="quotation-pagination">
              <span>
                Showing{" "}
                {filteredRows.length
                  ? `${(currentPage - 1) * perPage + 1}–${Math.min(
                      currentPage * perPage,
                      filteredRows.length
                    )}`
                  : "0"}{" "}
                of {filteredRows.length} records
              </span>
              <div className="quotation-pagination-btns">
                <button
                  aria-label="Previous page"
                  disabled={currentPage <= 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  <LuChevronLeft />
                </button>
                <button
                  aria-label="Next page"
                  disabled={currentPage * perPage >= filteredRows.length}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  <LuChevronRight />
                </button>
              </div>
            </footer>
          </section>
          <p className="rcti-c01-footer-note">
            New RCTI starts with a supplier and eligibility checks. Drafts do
            not create a supplier payable.
          </p>
        </main>
      </div>

      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <BillingModal
        open={showBillingModal}
        handleConfirm={() => {
          navigate("/subscriptions");
        }}
        handleCancel={() => {
          setShowBillingModal(false);
        }}
        closeModalClick={() => {
          setShowBillingModal(false);
        }}
        message={genericMessage.billingMsg}
        title={genericMessage.noCreditAvailableTitle}
      />
      <LoadingModal loading={false} />

        <SendInvoiceModal
          open={open}
          onClose={handleClose}
          documentLabel="RCTI"
          messageOnly
          invoiceNumber={emailRow?.rctiNumber}
          customerName={emailRow?.supplierCompanyName || emailRow?.supplierName || "Supplier"}
          customerEmail={templateValues?.customerEmailAddress?.[0] || ""}
          invoiceDate={emailRow?.rctiDate}
          finalAmount={Number(emailRow?.finalAmount || 0)}
          organisation={organisationName}
          invoiceStatus="Issued"
          templateData={templateValues}
          onSend={handleSend}
          onViewInvoice={() => navigate(`/rcti/view/${emailRow?._id}`)}
          darkMode={darkMode}
          mode="resend"
        />
    </div>
  );
}

export default InvoicesSearch;
